var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"RightBottom"}},[_c('dv-border-box-13',[_c('HeaderTitle',{attrs:{"title":"评价反馈"}}),_c('RightBottomEarch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }